import type { TFurniture } from "types/elevationReferences.type"
import { isCountertop, isCustomFurniture, isModelConfirmed, isOtherFurniture } from "./furnitureModel.helpers"
import style from "./FurnitureModelLabel.module.scss"

const { modelNumber, modelNotConfirmed, countertop } = style

type Props = { item: TFurniture }

export const FurnitureModelLabel = ({ item }: Props) => {
	// #1346 — its number lives in the linked definition, not in `selected_model_number` (always null
	// for a custom object), so without this branch every custom object read "Model not confirmed".
	// Before the Other branch: neither type has a category, and order is what tells them apart.
	if (isCustomFurniture(item)) {
		const customModelNumber = item.custom_object_config?.custom_model_number?.model_number?.trim()
		if (customModelNumber) return <span className={modelNumber}>{customModelNumber}</span>
		return <span className={modelNotConfirmed}>Custom</span>
	}

	if (isOtherFurniture(item)) {
		const name = item.fixed_price_config?.name?.trim()
		if (name) return <span className={modelNumber}>{name}</span>
		return <span className={modelNotConfirmed}>Other</span>
	}

	if (isCustomFurniture(item)) {
		const model = item.custom_object_config?.custom_model_number?.model_number
		if (model) return <span className={modelNumber}>{model}</span>
		return <span className={modelNotConfirmed}>Custom</span>
	}

	if (isModelConfirmed(item)) {
		return <span className={modelNumber}>{item.selected_model_number!.model_number}</span>
	}

	if (isCountertop(item)) {
		return <span className={countertop}>Countertop</span>
	}

	return <span className={modelNotConfirmed}>Model not confirmed</span>
}
